var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "批量提交审核",
        visible: _vm.dialog.visible,
        width: "1100px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.dialog, "visible", $event)
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialog.loading,
              expression: "dialog.loading",
            },
          ],
          ref: "table",
          attrs: {
            data: _vm.pagedBodys,
            "row-key": "id",
            "highlight-current-row": "",
            stripe: "",
            border: "",
            "max-height": "520px",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "selection",
              "reserve-selection": "",
              width: "50",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "资源位code",
              prop: "code",
              "min-width": "140",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "优先级",
              prop: "pri",
              width: "80",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "标题",
              prop: "title",
              "min-width": "120",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "icon",
              prop: "icon",
              width: "90",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.icon
                      ? _c("el-image", {
                          staticStyle: { width: "60px", height: "34px" },
                          attrs: {
                            src: row.icon,
                            "preview-src-list": [row.icon],
                          },
                        })
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "图片",
              prop: "image",
              width: "90",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.image && row.image.trim()
                      ? _c("el-image", {
                          staticStyle: { width: "60px", height: "34px" },
                          attrs: {
                            src: row.image,
                            "preview-src-list": [row.image],
                          },
                        })
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "描述",
              prop: "descInfo",
              "min-width": "120",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "渠道配置",
              prop: "appidFilterNames",
              "min-width": "120",
              align: "center",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(row.appidFilterNames || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "事件类型",
              prop: "eventType",
              width: "120",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getEventTypeName(row.eventType)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "状态",
              prop: "status",
              width: "80",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: row.status === 1 ? "success" : "info",
                          size: "mini",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.status === 1 ? "上架" : "下架") +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "审核状态",
              prop: "auditStatus",
              width: "90",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", { attrs: { type: "warning", size: "mini" } }, [
                      _vm._v(_vm._s(_vm.getAuditStatusName(row.auditStatus))),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrap" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, pager, next",
              total: _vm.table.bodys.length,
              "page-size": _vm.page.size,
              "current-page": _vm.page.current,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "current", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "current", $event)
              },
              "current-change": _vm.handlePageChange,
            },
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.hide } }, [_vm._v("取 消")]),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                disabled: _vm.selection.length === 0,
                loading: _vm.dialog.submitting,
              },
              on: { click: _vm.handleSubmit },
            },
            [
              _vm._v(
                "\n      提交审核" +
                  _vm._s(
                    _vm.selection.length > 0 ? ` (${_vm.selection.length})` : ""
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }